import { createAction } from 'redux-act';

export interface ICollectionsOverviewSortPayload {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

export const setCollectionsOverviewPage = createAction<number>('SET_COLLECTIONS_OVERVIEW_PAGE');
export const setCollectionsOverviewSearch = createAction<string>('SET_COLLECTIONS_OVERVIEW_SEARCH');
export const setCollectionsOverviewSort = createAction<ICollectionsOverviewSortPayload>(
  'SET_COLLECTIONS_OVERVIEW_SORT'
);
export const resetCollectionsOverviewUi = createAction('RESET_COLLECTIONS_OVERVIEW_UI');
